module.exports = __webpack_public_path__ + "static/media/defaulttheme.9c600472.png";